import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import DateTime from '_class/DateTime';

var Date = /*#__PURE__*/function (_Component) {
  _inherits(Date, _Component);

  var _super = _createSuper(Date);

  function Date(props) {
    _classCallCheck(this, Date);

    return _super.call(this, props);
  }

  _createClass(Date, [{
    key: "capitalizeFirstLetter",
    value: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }, {
    key: "formatDate",
    value: function formatDate() {
      var dateTime = new DateTime(this.props.children);
      return this.capitalizeFirstLetter(dateTime.getLongDate());
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("time", {
        className: "date",
        dateTime: this.props.children
      }, this.formatDate());
    }
  }]);

  return Date;
}(Component);

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(Date);